import {ApiV0Crm} from '../api.v0.crm';
import {RestApiService} from '../../../rest-api.service';
import {
    BaseTaskCreateReq,
    BaseTaskRes,
    BaseTaskUpdateReq,
    TaskEffortCreateReq,
    TaskEffortRes,
    TaskEffortUpdateReq,
} from '../../../../contracts/v0/crm';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

export class ApiV0CrmTask {
    segment = '/task'
    taskEffort: string = ''
    taskReference: string = ''

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment
        this.taskEffort = this.segment + '/effort'
        this.taskReference = this.segment + '/reference'
    }

    search(searchModel?: SearchModel) {
        return this.rest.post<SearchModel, BaseCollectionModel<BaseTaskRes>>(this.segment + '/search', BaseTaskRes, searchModel);
    }

    bulkDelete(ids: string[]) {
        return this.rest.delete<void>(this.segment, {}, ids);
    }

    update(update: BaseTaskUpdateReq) {
        return this.rest.patch<BaseTaskUpdateReq, BaseTaskRes>(this.segment, BaseTaskRes, update);
    }

    createTask(createReq: BaseTaskCreateReq) {
        return this.rest.post<BaseTaskCreateReq, BaseTaskRes>(`${this.segment}`, BaseTaskRes, createReq);
    }

    addEffort(effortCreate: TaskEffortCreateReq) {
        return this.rest.post<TaskEffortCreateReq, TaskEffortRes>(this.taskEffort, TaskEffortRes, effortCreate);
    }

    updateEffort(effortUpdate: TaskEffortUpdateReq) {
        return this.rest.patch<TaskEffortUpdateReq, TaskEffortRes>(this.taskEffort, TaskEffortRes, effortUpdate);
    }

    deleteEffort(ids: string[]) {
        return this.rest.delete<void>(this.taskEffort, {}, ids);
    }
}